import React, { useState, createContext, useContext } from "react";

// context for managing registration data in Register screen
const initalState = {
    messages: [],
};

const ChatbotContext = createContext(initalState);

export const ChatbotProvider = ({ children }) => {
  const [messages, setMessages] = useState([]); // Stores questions and answers
  const [sessionId, setSessionId] = useState('');
  return (
    <ChatbotContext.Provider
      value={{
        messages, setMessages, sessionId, setSessionId
      }}
    >
      {/* {renderComponent()} */}
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbotContext = () => useContext(ChatbotContext);
